export const RouteAccess = 'Access'
export const RouteAccount = 'Account'
export const RouteAccountSettings = 'AccountSettings'
export const RouteApp = 'App'
export const RouteApps = 'Apps'
export const RouteChangeEmail = 'ChangeEmail'
export const RouteChangePassword = 'ChangePassword'
export const RouteConfirmDeleteAccount = 'RouteConfirmDeleteAccount'
export const RouteConfirmEmail = 'ConfirmEmail'
export const RouteLogin = 'Login'
export const RouteLoginOptions = 'LoginOptions'
export const RouteNotFound = 'NotFound'
export const RouteOAuth = 'OAuth'
export const RouteOAuthSignup = 'OAuthSignup'
export const RouteOAuthComplete = 'OAuthComplete'
export const RouteOAuthSocialLoginCallback = 'OAuthSocialLoginCallback'
export const RouteOAuthIntegration = 'OAuthIntegration'
export const RouteOAuthLink = 'OAuthLink'
export const RouteOAuthProceed = 'OAuthProceed'
export const RouteOAuthService = 'OAuthService'
export const RouteProfile = 'Profile'
export const RouteRecover = 'Recover'
export const RouteSetEmail = 'SetEmail'
export const RouteSignUp = 'SignUp'
export const RouteSignupConfirmEmail = 'SignupConfirmEmail'
export const RouteVerify = 'Verify'
